import { Action } from '@ngrx/store';

export enum AsyncValidationsActionTypes {
  ADD_ITEM = '[AsyncValidations] add validator form',
  REMOVE_ITEM = '[AsyncValidations] remove validator form',
  SET_PURCHASE_ORDER_VALIDATING = '[AsyncValidations] set purchase order validating',
  SET_PURCHASE_ORDER_VALID = '[AsyncValidations] set purchase order valid',
  SET_REPEAT_PURCHASE_ORDER_VALID = '[AsyncValidations] set repeat purchase order valid',
  RESET = '[AsyncValidations] reset',
}

export class AsyncValidationsAddItemAction implements Action {
  readonly type = AsyncValidationsActionTypes.ADD_ITEM;

  constructor() {}
}

export class AsyncValidationsRemoveItemAction implements Action {
  readonly type = AsyncValidationsActionTypes.REMOVE_ITEM;

  constructor(public payload: number) {}
}

export class PurchaseOrderValidatingAction implements Action {
  readonly type = AsyncValidationsActionTypes.SET_PURCHASE_ORDER_VALIDATING;

  constructor(public payload: { formId: number; purchaseOrderValidating: boolean }) {}
}

export class PurchaseOrderValidAction implements Action {
  readonly type = AsyncValidationsActionTypes.SET_PURCHASE_ORDER_VALID;

  constructor(public payload: { formId: number; purchaseOrderValid: boolean }) {}
}

export class RepeatPurchaseOrderValidAction implements Action {
  readonly type = AsyncValidationsActionTypes.SET_REPEAT_PURCHASE_ORDER_VALID;

  constructor() {}
}

export class AsyncValidationsResetAction implements Action {
  readonly type = AsyncValidationsActionTypes.RESET;

  constructor(public payload?: any) {}
}

export type AsyncValidationsActions =
  | AsyncValidationsAddItemAction
  | AsyncValidationsRemoveItemAction
  | PurchaseOrderValidatingAction
  | PurchaseOrderValidAction
  | RepeatPurchaseOrderValidAction
  | AsyncValidationsResetAction;
